define('models/parts/menu/done-button',[
    'underscore', 'backbone', 'utils', 'moment',
    'services/api',
    'services/i18n'
    // views
], function(_, Backbone, U, moment, API, i18n) {

    var MDoneButton = Backbone.Model.extend({
        defaults: {
            title: i18n.t('messages:tooltip-mark-as-done'),
            skipTranslation: true,
            content: "<span class='fa fa-check'></span>",
            itemClass: "btn-action-done big-action ",
            animatedcheck: true,
            callback: _.noop
        },
    });

    // Return the model for the module
    return MDoneButton;
});

